import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import withNotification from 'components/hoc/withNotification';
import colors from 'styles/colors';
import useUserStore from 'store/UserStore';
import useJobCancel from 'hooks/useJobCancel';

const JobsRowActionMenu = ({ disabled, jobOwnerId, jobId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const user = useUserStore((state) => state.user);
  const { cancelJob } = useJobCancel(jobId);
  const canCancel = !disabled && jobOwnerId === user.uid;

  const handleCancel = () => {
    cancelJob();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        sx={{ color: colors.text.primary, padding: 0 }}
        onMouseDown={handleClick}
      >
        <MoreVertIcon sx={{ fontSize: '20px' }} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
          sx: { padding: '10px 20px 10px 5px !important', background: colors.background.paper_11p },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={!canCancel ? () => {} : handleCancel}
          disabled={!canCancel}
        >
          Cancel
        </MenuItem>
      </Menu>
    </div>
  );
};

export default withNotification(JobsRowActionMenu);
